import { useAdminFilters } from '../../contexts/AdminFiltersContext';

export default function StatsFilters() {
  const { from, to, market, setFrom, setTo, setMarket } = useAdminFilters();

  return (
    <div className="flex flex-wrap items-end gap-3 p-3 border-b border-gray-200 bg-white sticky top-0 z-10">
      <div className="flex flex-col">
        <label className="text-xs text-gray-500 mb-1">From</label>
        <input
          type="date"
          value={from}
          onChange={(e) => setFrom(e.target.value)}
          className="border border-gray-300 rounded px-2 py-1 text-sm"
        />
      </div>
      <div className="flex flex-col">
        <label className="text-xs text-gray-500 mb-1">To</label>
        <input
          type="date"
          value={to}
          onChange={(e) => setTo(e.target.value)}
          className="border border-gray-300 rounded px-2 py-1 text-sm"
        />
      </div>
      <div className="flex flex-col">
        <label className="text-xs text-gray-500 mb-1">Market</label>
        <select
          value={market}
          onChange={(e) => setMarket(e.target.value)}
          className="border border-gray-300 rounded px-2 py-1 text-sm"
        >
          <option value="all">All markets</option>
          <option value="it">Italia</option>
          <option value="es">España</option>
        </select>
      </div>
    </div>
  );
}
